// extracted by mini-css-extract-plugin
export default {"wrapper-left":"SectionHeaderComponent_wrapper-left__7OSLj","head":"SectionHeaderComponent_head__2pKUO"};